import { render, staticRenderFns } from "./ButtonsCadastro.vue?vue&type=template&id=31910fbc"
import script from "./ButtonsCadastro.vue?vue&type=script&lang=js"
export * from "./ButtonsCadastro.vue?vue&type=script&lang=js"
import style0 from "./ButtonsCadastro.vue?vue&type=style&index=0&id=31910fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports